import { render, staticRenderFns } from "./BalanceChange.vue?vue&type=template&id=58343ea8&scoped=true"
import script from "./BalanceChange.vue?vue&type=script&lang=js"
export * from "./BalanceChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cac_qoazctsovguzye32rwzarzod4q/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58343ea8",
  null
  
)

export default component.exports